import baseAPI from '@/http'

const router = 'api/pergunta/pergunta'
const routerTemas = 'api/Tema'
const routerEixos = 'api/projeto/Eixo'

export const perguntaAPI = {
  create: (data) => baseAPI.post(router, data),
  update: (data) => baseAPI.put(router, data),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getUltimaPergunta: () => baseAPI.get(`${router}/retonar-ultima-pergunta-cadastrada`),
  putAtualizarQuantidade: (temaId) => baseAPI.get(`${router}/atualizar-quantidade/${temaId}`),
  list: () => baseAPI.get(router),
  getTemas: () => baseAPI.get(routerTemas),
  getEixos: () => baseAPI.get(routerEixos)

}
